module.exports = __webpack_public_path__ + "54440f4984a441847006159b3ffc0590.png";